import React, { Component } from "react";
import MarketplaceLive from '../home/MarketplaceLive';
import MainLoader from '../home/MainLoader';

class MarketplacePastClasses extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		showLoader: false,
    }
	
}
 
componentDidMount(){
	
}

updateStateFromChild=(state)=>{
	this.setState(state);
}

  render() {
	 return (
		<div className={this.props.isMarketplace0 ? "" : "booked_pop_content pastPage"}>
			<div className={this.props.isMarketplace0 ? "" : "bookmarked_content addWidth"}>
			    { this.props.isMarketplace0 != true &&
					<div className="close_pops"	onClick={() => this.props.updateStateFromChild({openPastClasses: false})}></div>
				}
				<div className={"achievementTitle " + (this.props.isMarketplace0 ? "margtp130m" : "")}>Past classes</div> 
				<div>
					<MarketplaceLive
						state={this.state}
						updateStateFromChild = {this.updateStateFromChild}
						isMarketplace0={this.props.isMarketplace0}
						parentComponent='pastClasses'
					history={this.props.history}></MarketplaceLive>
				</div>
			</div>
			{ this.state.showLoader && <MainLoader></MainLoader> }
		</div>
    );
  }
}
export default MarketplacePastClasses;
